import { combineReducers } from '@reduxjs/toolkit'
import application from './application/reducer'
import userAuth from './userAuth/reducer'
import userProfile from './userProfile/reducer'
import buyCrypto from './buyCrypto/reducer'
import sellCrypto from './sellCrypto/reducer'
import notifications from './notifications/reducer'
import tradeHistory from './tradeHistory/reducer'
import userVerificationDetails from './userVerificationDetails/reducer'

const reducer = combineReducers({
  application,
  userAuth,
  userProfile,
  buyCrypto,
  sellCrypto,
  notifications,
  tradeHistory,
  userVerificationDetails
})

export default reducer
